import { GradientColorStop } from "./GradientColorStop"

/**
 * @public
 */
export interface MultiStopGradient {
    stops: readonly GradientColorStop[]
}

const multiStopGradientKeys: (keyof MultiStopGradient)[] = ["stops"]

export function isMultiStopGradient(value: any): value is MultiStopGradient {
    return value && multiStopGradientKeys.every(key => key in value)
}
